import { render, staticRenderFns } from "./TabTides.vue?vue&type=template&id=1c1e1b06&scoped=true"
import script from "./TabTides.vue?vue&type=script&lang=js"
export * from "./TabTides.vue?vue&type=script&lang=js"
import style0 from "./TabTides.vue?vue&type=style&index=0&id=1c1e1b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e1b06",
  null
  
)

export default component.exports